<template>
    <svg v-if="isEditing" t="1581746765952" class="icon" style="fill: white;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2080" width="200" height="200"><path d="M64 160c0-53.024 42.976-96 96-96l64 0L224 0 160 0C71.648 0 0 71.616 0 160l0 64 64 0L64 160zM736 480l-192 0L544 256c0-17.696-14.304-32-32-32s-32 14.304-32 32l0 256c0 17.696 14.304 32 32 32l224 0c17.696 0 32-14.304 32-32C768 494.336 753.696 480 736 480zM960 512c0-247.392-200.576-448-448-448C264.576 64 64 264.608 64 512c0 169.696 94.368 317.28 233.44 393.312L192 1024l96 0 85.92-85.92C417.44 952.192 463.776 960 512 960s94.56-7.808 138.08-21.92L736 1024l96 0-105.44-118.688C865.632 829.28 960 681.696 960 512zM512 896C299.936 896 128 724.096 128 512 128 299.936 299.936 128 512 128c212.096 0 384 171.936 384 384C896 724.096 724.096 896 512 896zM864 0l-64 0 0 64 64 0c53.024 0 96 42.976 96 96l0 64 64 0L1024 160C1024 71.616 952.384 0 864 0z" p-id="2081"></path></svg>
</template>
<script>
var CronJob = require('cron').CronJob;

export default {
    props:['isEditing', 'cronExpression'],
    mounted() {
        
    },
    watch: {
        cronExpression:{
            handler(){
                this.number = -1;
                if(this.job){
                    this.job.stop();
                }
                this.job = new CronJob(this.cronExpression||'* * * * * *', ()=>{
                    this.emit();
                }, null, true);
                this.job.start();
                this.emit();
            },
            immediate:true
        }
    },

    methods: {
        emit(){
            this.number++;
            this.$emit('on-tick', {
                timestamp:Date.now(),
                number:this.number
            });
        }
    },
}
</script>